import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  CircularProgress
} from "@mui/material";


import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip
} from "recharts";


import {
  getTicketStatusReport
} from "../../services/reportService";





function TicketStatusChart(){


const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);





const COLORS = [

"#2563eb",

"#7c3aed",

"#22c55e",

"#16a34a",

"#64748b"

];







useEffect(()=>{


const loadStatus = async()=>{


try{


const response = await getTicketStatusReport();


setData(response);


}

catch(error){


console.error(

"Status Report Error:",

error

);


}

finally{


setLoading(false);


}


};



loadStatus();


},[]);









if(loading){


return(

<Box

height="100%"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}








return(


<Box

height="100%"

>





<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"text.primary",

mb:2

}}

>

Ticket Status Distribution

</Typography>









<ResponsiveContainer

width="100%"

height={250}

>


<PieChart>





<Pie

data={data}

dataKey="value"

nameKey="name"

cx="50%"

cy="45%"

innerRadius={55}

outerRadius={85}

paddingAngle={3}

label={({value})=>value}

>



{

data.map((item,index)=>(


<Cell

key={index}

fill={

COLORS[index % COLORS.length]

}

/>


))


}



</Pie>







<Tooltip />







<Legend

verticalAlign="bottom"

height={35}

wrapperStyle={{

fontSize:12

}}

/>







</PieChart>


</ResponsiveContainer>







</Box>


);


}


export default TicketStatusChart;